import { decamelize } from 'humps'

export default function convertObjAttrsCamelToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertObjAttrsCamelToSnakeCase)
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const camelKey = key !== '_id' ? decamelize(key) : key
        newObj[camelKey] = convertObjAttrsCamelToSnakeCase(obj[key])
      }
    }
    return newObj
  }
  return obj
}
